import React from 'react';

export default function InvestorsHero() {
  return (
    <div className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto text-center space-y-6">

        {/* Headline */}
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
          Invest in the Future of Financial Market Infrastructure
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
          Million2Trillion (M2T) is building the world’s most trusted platform for financial market professionals — across traders, educators, brokers, tool creators, and investors.
        </p>

        {/* Key Promise Points */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8">
          <div className="bg-gray-900 rounded-xl p-6 shadow border border-gray-700">
            <h3 className="text-xl font-semibold mb-2">🏗️ Long-Term Infrastructure Play</h3>
            <p className="text-sm text-gray-400">
              Your capital empowers a unified marketplace for real professionals — verified and role-based.
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-6 shadow border border-gray-700">
            <h3 className="text-xl font-semibold mb-2">🌍 Global Ecosystem Expansion</h3>
            <p className="text-sm text-gray-400">
              Backed by scalable architecture and category-based onboarding across 200+ roles and 29+ verticals.
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-6 shadow border border-gray-700">
            <h3 className="text-xl font-semibold mb-2">💼 Clear Monetization Channels</h3>
            <p className="text-sm text-gray-400">
              From SaaS dashboards and content engines to verified services and investor zones — revenue at every layer.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
